import React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { CpsGridCell } from './CpsGridCell';
import { EMPTY_VALUE } from '@cs-cms/types';

const renderPills = (value: unknown): React.ReactNode => {
  if (!value) {
    return null;
  }

  if (Array.isArray(value)) {
    return (
      <div>
        {value.map((item, index) => (
          <div key={`${item}-${index}`} className="pill">
            {item}
          </div>
        ))}
      </div>
    );
  }

  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    React.isValidElement(value)
  ) {
    return value;
  }

  return String(value);
};

export const MultiChoiceCell = (props: GridCustomCellProps) => {
  const field = props.field || EMPTY_VALUE;
  const value = props.dataItem[field];

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title=""
    >
      {renderPills(value)}
    </CpsGridCell>
  );
};
